/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IEditClaimModalControllerScope extends IBaseModalControllerScope {
        claim: Wars.Domain.Model.ClaimDefinition;
        mapping: any;
        systemClaimGroups: Wars.Domain.Model.ClaimGroup[];
        variableTypeContext: Array<number>;
        codeGroups: Wars.Domain.Model.Codes.CodeGroup[];
        processActions: Wars.Domain.Model.ProcessAction[];
    }

    export class EditClaimModalController extends BaseModalController {
        scope: IEditClaimModalControllerScope;

        constructor(
            $scope: IEditClaimModalControllerScope,
            claim: Wars.Domain.Model.ClaimDefinition,
            mapping: any,
            systemClaimGroups: Wars.Domain.Model.ClaimGroup[],
            variableTypeContext: Array<number>,
            codeGroups: Array<Wars.Domain.Model.Codes.CodeGroup>,
            processActions: Wars.Domain.Model.ProcessAction[],
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.claim = claim;
            this.scope.mapping = mapping;
            this.scope.systemClaimGroups = systemClaimGroups;
            this.scope.variableTypeContext = variableTypeContext;
            this.scope.codeGroups = codeGroups;
            this.scope.processActions = processActions;
        }
    }
}

warsApp.registerController("EditClaimModalController", ["$scope", "claim", "mapping", "systemClaimGroups", "variableTypeContext", "codeGroups", "processActions", "close"]);